<template>
  <div class="more-exit">
    <div class="ha-des">
      <p class="black">问：跟读、背诵时，红色、黑色、蓝色各是什么含义？</p>
      <p>答：在跟读或背诵的页面有“小问号”的图标，可点击查看不同的颜色代表不同的正确程度，具体如下。</p>
    </div>
    <div class="ha-img">
      <img src="./img/color.png" alt="">
    </div>
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
  @import '../../../src/assets/css/basic.scss';

  .more-exit {
    padding: 0 p2r(20);
    width: 100%;
    .ha-des {
      padding: p2r(10) 0;
      font-size: p2r(15);
      color: $a77;
      p {
        margin: p2r(10) 0;
      }
      a {
        color: $blue;
      }
    }
    .ha-img {
      width: 100%;
      text-align: center;
      img {
        width: 100%;
      }
    }
  }
</style>
<script>
  export default{
    data(){
      return {}
    },
    created(){
      document.title = '其他问题? 可瀚学堂-深圳市格熙信息科技有限公司'
      this.$sendAnalytics('点击跟读、背诵时，红色、黑色、蓝色各是什么含义')
    },
    methods: {
      skip(name) {
        this.$router.push({
          name: name
        });
      }
    },
    components: {}
  }
</script>
